import { gql, useQuery } from '@apollo/client';

export type PlatformListData = {
  platformList: string[];
};

const GET_PLATFORM_LIST = gql`
  query GetPlatformList {
    platformList
  }
`;

type UsePlatformDictionaryReturnType = {
  data?: PlatformListData;
  loading: boolean;
};

export const usePlatformDictionary = (): UsePlatformDictionaryReturnType => {
  const { data, error, loading } =
    useQuery<PlatformListData>(GET_PLATFORM_LIST);

  if (error || !data) {
    // throw error;
  }

  return { data, loading };
};
